"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLoop(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm11.5 4h-3.5v-1.4a.61037.61037 0 0 0 -.27667-.51893.52.52 0 0 0 -.55451-.00195l-3.88891 2.4a.62477.62477 0 0 0 0 1.04194l3.88891 2.4a.52.52 0 0 0 .55451-.00208.61028.61028 0 0 0 .27667-.51898v-1.50266h3.5a2.60263 2.60263 0 1 1 0 5.20526h-7a2.5922 2.5922 0 0 1 -1.59918-4.64044l-.14636-.09033a1.61814 1.61814 0 0 1 -.75446-1.37183 1.602 1.602 0 0 1 .03308-.25806 4.49644 4.49644 0 0 0 2.46692 8.25806h7a4.5 4.5 0 0 0 0-9z' })));
}
exports.default = SvgLoop;
